import { render, staticRenderFns } from "./CalculationRequestForm.vue?vue&type=template&id=24743132&"
import script from "./CalculationRequestForm.vue?vue&type=script&lang=js&"
export * from "./CalculationRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports